import * as svg from "../../../assets/august-logo-solid-circle.svg";

import {iconBuilder} from "./iconBuilder";

export const AugustCircleIcon = iconBuilder(svg, "AugustCircleIcon", "0 0 1150.9 1150.9");
